import React from 'react'

import './styles.css'

function PopularCategories({ categoryImages }) {
  return (
    <div id="PopularCategories" className="categories-grid">
      {categoryImages.map((cat) => (
        <a
          key={cat.id}
          href={`/tutorial_categories/${cat.tutorialCategorySlug}`}
          className={`category-card ${cat.tutorialCategorySlug}`}
        >
          <img src={cat.image.original} alt={cat.name} />
          <div className="overlay" />
          <div className="category-name">{cat.name}</div>
        </a>
      ))}
    </div>
  )
}

export default PopularCategories
